(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["motoryva-hero-vehicle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vehicle-fitment-selector')) {
    customElements.define(
      'vehicle-fitment-selector',
      class extends HTMLElement {
        async connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.form = this.querySelector('[data-vehicle-form]');
          this.brandSelect = this.querySelector('[data-vehicle-brand]');
          this.modelSelect = this.querySelector('[data-vehicle-model]');
          this.submitButton = this.querySelector('[data-vehicle-submit]');
          this.status = this.querySelector('[data-vehicle-status]');

          try {
            const payload = Array.from(this.querySelectorAll('[data-vehicle-selector-payload]'))
              .map((node) => node.textContent.trim())
              .join('');
            const bytes = Uint8Array.from(atob(payload), (character) => character.charCodeAt(0));
            const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
            this.data = JSON.parse(await new Response(stream).text());
            this.populate(
              this.brandSelect,
              this.data.brands,
              this.brandSelect.options[0].textContent,
              (brand) => brand.name.toLocaleLowerCase('fr').replace(/(^|[\s/-])\p{L}/gu, (letter) => letter.toLocaleUpperCase('fr')),
            );
            this.brandSelect.disabled = false;
            this.status.textContent = '';
            this.bindEvents();
          } catch (error) {
            this.status.textContent = this.dataset.error;
          }
        }

        bindEvents() {
          this.brandSelect.addEventListener('change', () => {
            const brand = this.find(this.data.brands, this.brandSelect.value);
            this.resetSelect(this.modelSelect);
            this.status.textContent = '';
            this.submitButton.disabled = true;
            if (!brand) return;
            this.populate(
              this.modelSelect,
              brand.models,
              this.modelSelect.options[0].textContent,
              (model) => model.name,
            );
          });

          this.modelSelect.addEventListener('change', () => {
            const brand = this.find(this.data.brands, this.brandSelect.value);
            const model = this.find(brand?.models, this.modelSelect.value);
            this.status.textContent = '';
            this.submitButton.disabled = true;
            if (!model) return;
            const productCount = model.types?.reduce((total, type) => total + Number(type.count || 0), 0) || 0;
            this.submitButton.disabled = productCount < 1;
            this.status.textContent =
              productCount > 0
                ? ''
                : this.dataset.noResults;
          });

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            const brand = this.find(this.data.brands, this.brandSelect.value);
            const model = this.find(brand?.models, this.modelSelect.value);
            if (!brand || !model) return;

            const vehicleTags = [
              `CompatMarque:${brand.id}`,
              `CompatModele:${brand.id}|${model.id}`,
            ];
            const tagPath = vehicleTags.map((tag) => encodeURIComponent(tag)).join('+');
            window.location.assign(`${this.dataset.collectionUrl}/${tagPath}`);
          });
        }

        find(items, id) {
          return items?.find((item) => String(item.id) === String(id));
        }

        populate(select, items, placeholder, label) {
          select.replaceChildren(new Option(placeholder, ''));
          for (const item of items) select.add(new Option(label(item), item.id));
          select.disabled = false;
        }

        resetSelect(select) {
          select.selectedIndex = 0;
          while (select.options.length > 1) select.remove(1);
          select.disabled = true;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
